/**
 * Dismissal types for user-facing alerts in the notification/alert system.
 *
 * - `Snooze`: User chooses to temporarily hide the alert for a defined duration.
 * - `Permanent`: User dismisses the alert for good (does not appear again unless re-triggered by backend logic).
 *
 * Use this enum instead of raw string literals when handling alert dismissal actions (API, UI, store).
 */
export enum AlertDismissTypeEnum {
  /** Temporarily hide the alert, prompting reappearance after a snooze period. */
  Snooze = 'snooze',

  /** Permanently hide the alert for this user. */
  Permanent = 'permanent',
}
